import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxStarsModule } from 'ngx-stars';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { OnlineOrderRoutingModule } from './online-order-routing.module';

import { GoogleMapsModule } from '@angular/google-maps';

// components
import { OnlineOrderComponent } from './online-order.component';
import { RestaurantMenuComponent } from './restaurant-menu/restaurant-menu.component';
import { ProductsListComponent } from './restaurant-menu/products-list/products-list.component';
import { ProductDetailsComponent } from './restaurant-menu/products-list/product-details/product-details.component';
import { CartComponent } from './restaurant-menu/cart/cart.component';
import { CheckoutComponent } from './restaurant-menu/checkout/checkout.component';
import { CustomerDetailsComponent } from './restaurant-menu/checkout/customer-details/customer-details.component';
import { NavbarComponent } from './restaurant-menu/navbar/navbar.component';
import { QtyButtonComponent } from './shared/components/qty-button/qty-button.component';
import { BottomNavbarComponent } from './shared/components/bottom-navbar/bottom-navbar.component';
import { MyOrdersComponent } from './restaurant-menu/my-orders/my-orders.component';
import { ContactButtonsComponent } from './shared/components/contact-buttons/contact-buttons.component';
import { CustomerLoginComponent } from './restaurant-menu/customer-login/customer-login.component';
import { OnlineOrderDetailsComponent } from './restaurant-menu/my-orders/online-order-details/online-order-details.component';
import { OpenHoursComponent } from './open-hours/open-hours.component';

import { SharedModule } from '../shared/modules/shared.module';
import { OrderPizzaComponent } from '../shared/components/order-pizza/order-pizza.component';

// pipes
import { SharedPipes } from '../shared/pipes/shared-pipes.module';

@NgModule({
  declarations: [
    OnlineOrderComponent, 
    ProductsListComponent, 
    ProductDetailsComponent, 
    CartComponent, 
    CheckoutComponent, 
    CustomerDetailsComponent, 
    NavbarComponent, 
    QtyButtonComponent, 
    BottomNavbarComponent, 
    MyOrdersComponent, 
    ContactButtonsComponent, 
    CustomerLoginComponent, 
    OnlineOrderDetailsComponent, 
    OpenHoursComponent,
    RestaurantMenuComponent
  ],
  imports: [
    CommonModule,
    OnlineOrderRoutingModule,
    NgbModule,
    FontAwesomeModule,
    NgxStarsModule,
    FormsModule,
    NgSelectModule,
    SharedPipes,
    SharedModule,
    OrderPizzaComponent,
    GoogleMapsModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [
      provideNgxMask({validation: false, dropSpecialCharacters: true})
  ]
})
export class OnlineOrderModule { }
